import { Box, FormControlLabel, IconButton, Switch, TextField, Typography } from '@material-ui/core';
import { Add, Delete, LiveHelp } from '@material-ui/icons';
import { FieldArray, useFormikContext } from 'formik';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { TabletButton } from '@campfire/tablet-button';
import { APPLICATION_QUESTION_TYPE_FREE_TEXT } from '../../../admin/admin-console/admin-console-content-pages/admin-console-application-questions/application-questions-model';
import { ActivityFormValues } from './ActivityFormV2';

export const ActivityApplicationQuestionsField = () => {
  const { values, setFieldValue } = useFormikContext<ActivityFormValues>();
  const questions = values.applicationQuestions ?? [];

  return (
    <Box display='flex' flex='1 1 auto' flexDirection='column'>
      <Typography style={{ fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', color: '#333' }}>
        <LiveHelp style={{ fontSize: '14px', paddingRight: '5px' }} />
        Application Questions
      </Typography>
      <Typography style={{ fontSize: 12, color: '#808080', marginBottom: 8 }}>
        {
          'Questions specific to this activity, asked when a volunteer applies. Only used when the activity requires approval, and shown in addition to any global application questions.'
        }
      </Typography>

      <FieldArray name='applicationQuestions'>
        {(arrayHelpers) => (
          <Box ml={1} mt={1}>
            {questions.map((question, index) => (
              <Box
                key={question.activityApplicationQuestionId ?? question.listId}
                display='flex'
                alignItems='center'
                mb={1}
                style={{ gap: 8 }}
              >
                <TextField
                  fullWidth
                  size='small'
                  variant='outlined'
                  placeholder='Enter a question'
                  value={question.label}
                  onChange={(e) => setFieldValue(`applicationQuestions[${index}].label`, e.target.value)}
                />
                <FormControlLabel
                  control={
                    <Switch
                      color='primary'
                      size='small'
                      checked={question.required}
                      onChange={(e) => setFieldValue(`applicationQuestions[${index}].required`, e.target.checked)}
                    />
                  }
                  label={<Typography style={{ fontSize: 12, color: '#808080' }}>Required</Typography>}
                  style={{ whiteSpace: 'nowrap' }}
                />
                <IconButton size='small' onClick={() => arrayHelpers.remove(index)}>
                  <Delete fontSize='small' />
                </IconButton>
              </Box>
            ))}

            <TabletButton
              size='small'
              variant='outlined'
              color='primary'
              startIcon={<Add />}
              onClick={() =>
                arrayHelpers.push({
                  activityApplicationQuestionId: undefined,
                  listId: uuidv4(),
                  label: '',
                  type: APPLICATION_QUESTION_TYPE_FREE_TEXT,
                  required: false,
                  order: questions.length,
                })
              }
            >
              {'Add question'}
            </TabletButton>
          </Box>
        )}
      </FieldArray>
    </Box>
  );
};
